import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-55959f76")

_pushScopeId("data-v-55959f76")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body pt-0" }
const _hoisted_3 = {
  key: 1,
  class: "table-responsive newDropdown"
}
const _hoisted_4 = { class: "table table-row-dashed align-middle gs-0 gy-4" }
const _hoisted_5 = { class: "fw-bolder text-muted" }
const _hoisted_6 = {
  class: "min-w-140px fs-5",
  scope: "col"
}
const _hoisted_7 = {
  class: "min-w-140px fs-5",
  scope: "col"
}
const _hoisted_8 = {
  class: "min-w-140px fs-5",
  scope: "col"
}
const _hoisted_9 = {
  class: "min-w-140px fs-5",
  scope: "col"
}
const _hoisted_10 = {
  class: "min-w-140px fs-5",
  scope: "col"
}
const _hoisted_11 = {
  class: "min-w-140px fs-5",
  scope: "col"
}
const _hoisted_12 = {
  class: "min-w-100px fs-5",
  scope: "col"
}
const _hoisted_13 = { class: "sortable" }
const _hoisted_14 = { class: "py-5" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = {
  key: 0,
  class: "fs-6"
}
const _hoisted_17 = {
  key: 1,
  class: "fs-6"
}
const _hoisted_18 = {
  key: 0,
  class: "d-block fs-6"
}
const _hoisted_19 = {
  key: 1,
  class: "d-block fs-6"
}
const _hoisted_20 = {
  key: 0,
  class: "d-block fs-6"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "d-block fs-6"
}
const _hoisted_23 = {
  key: 0,
  class: "d-block fs-6"
}
const _hoisted_24 = {
  key: 1,
  class: "d-block fs-6"
}
const _hoisted_25 = {
  key: 0,
  class: "d-block fs-6"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 1,
  class: "d-block fs-6"
}
const _hoisted_28 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_29 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_30 = { class: "min-w-140px py-3 text-center" }
const _hoisted_31 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_32 = { class: "menu-item-wrapper" }
const _hoisted_33 = { class: "menu-item" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_35 = { class: "menu-item" }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 1,
  class: "card-footer"
}
const _hoisted_39 = { class: "text-muted fw-bold fs-6" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Search = _resolveComponent("Search")!
  const _component_TableContentLoader = _resolveComponent("TableContentLoader")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
    _createVNode(_component_Search, {
      selectData: _ctx.filterKeys,
      filter: true,
      filterPlaceholder: 'message.SELECT',
      onSearch: _ctx.searchHandler,
      inputPlaceholder: "message.ENTER_KEY_TO_SEARCH",
      onReloadListing: _ctx.getHomeScreens,
      onExportFile: _ctx.exportFile
    }, null, 8, ["selectData", "filterPlaceholder", "onSearch", "onReloadListing", "onExportFile"]),
    _createVNode("div", _hoisted_2, [
      (_ctx.loader)
        ? (_openBlock(), _createBlock(_component_TableContentLoader, { key: 0 }))
        : (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("table", _hoisted_4, [
              _createVNode("thead", null, [
                _createVNode("tr", _hoisted_5, [
                  _createVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('message.LABEL')), 1),
                  _createVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('message.TITLE')), 1),
                  _createVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('message.DESCRIPTION')), 1),
                  _createVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('message.BUTTON_TEXT')), 1),
                  _createVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('message.BUTTON_LINK')), 1),
                  _createVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('message.STATUS')), 1),
                  _createVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('message.ACTIONS')), 1)
                ])
              ]),
              _createVNode(_component_draggable, {
                modelValue: _ctx.homeScreens,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.homeScreens = $event)),
                onStart: _cache[2] || (_cache[2] = ($event: any) => (_ctx.drag = true)),
                onEnd: _cache[3] || (_cache[3] = ($event: any) => (_ctx.drag = false)),
                group: _ctx.homeScreens,
                onChange: _ctx.rowPosition,
                "item-key": "id",
                tag: "tbody"
              }, {
                item: _withId(({element}) => [
                  _createVNode("tr", _hoisted_13, [
                    _createVNode("td", _hoisted_14, [
                      _createVNode("div", _hoisted_15, [
                        (JSON.parse(element.label)[`${_ctx.systemLocale}`]?.name)
                          ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(JSON.parse(element.label)[`${_ctx.systemLocale}`]?.name), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_17, "N/A"))
                      ])
                    ]),
                    _createVNode("td", null, [
                      (JSON.parse(element.title)[`${_ctx.systemLocale}`]?.name)
                        ? (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(JSON.parse(element.title)[`${_ctx.systemLocale}`]?.name), 1))
                        : (_openBlock(), _createBlock("span", _hoisted_19, "N/A"))
                    ]),
                    _createVNode("td", null, [
                      (JSON.parse(element.description)[`${_ctx.systemLocale}`]?.name)
                        ? (_openBlock(), _createBlock("span", _hoisted_20, [
                            (JSON.parse(element.description)[`${_ctx.systemLocale}`].name.length < 30)
                              ? (_openBlock(), _createBlock("span", _hoisted_21, _toDisplayString(JSON.parse(element?.description)[`${_ctx.systemLocale}`]?.name), 1))
                              : _createCommentVNode("", true),
                            (JSON.parse(element.description)[`${_ctx.systemLocale}`].name.length >= 30)
                              ? (_openBlock(), _createBlock("span", {
                                  key: 1,
                                  title: JSON.parse(element?.description)[`${_ctx.systemLocale}`]?.name
                                }, _toDisplayString(JSON.parse(element?.description)[`${_ctx.systemLocale}`]?.name.substring(0, 30) + '...'), 9, ["title"]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createBlock("span", _hoisted_22, "N/A"))
                    ]),
                    _createVNode("td", null, [
                      (JSON.parse(element?.button_text)[`${_ctx.systemLocale}`]?.name)
                        ? (_openBlock(), _createBlock("span", _hoisted_23, _toDisplayString(JSON.parse(element.button_text)[`${_ctx.systemLocale}`].name), 1))
                        : (_openBlock(), _createBlock("span", _hoisted_24, "N/A"))
                    ]),
                    _createVNode("td", null, [
                      (element?.button_link)
                        ? (_openBlock(), _createBlock("span", _hoisted_25, [
                            (element.button_link.length < 20)
                              ? (_openBlock(), _createBlock("span", _hoisted_26, _toDisplayString(element.button_link), 1))
                              : _createCommentVNode("", true),
                            (element.button_link.length >= 20)
                              ? (_openBlock(), _createBlock("span", {
                                  key: 1,
                                  title: element.button_link
                                }, _toDisplayString(element.button_link.substring(0, 30) + '...'), 9, ["title"]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createBlock("span", _hoisted_27, "N/A"))
                    ]),
                    _createVNode("td", null, [
                      (element?.status == 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('message.ACTIVE')), 1))
                        : (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(_ctx.$t('message.INACTIVE')), 1))
                    ]),
                    _createVNode("td", _hoisted_30, [
                      _createVNode("button", {
                        class: "action-btn",
                        type: "button",
                        onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, element?.id))
                      }, [
                        _hoisted_31,
                        _createVNode("div", {
                          class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === element?.id }]
                        }, [
                          _createVNode("div", _hoisted_32, [
                            _createVNode("div", _hoisted_33, [
                              (_ctx.$can('edit_home_screen'))
                                ? (_openBlock(), _createBlock("a", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.editHomeScreen(element)),
                                    class: "menu-link me-1"
                                  }, [
                                    _hoisted_34,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('message.EDIT')), 1)
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_35, [
                              _createVNode("a", {
                                onClick: ($event: any) => (_ctx.deleteHomeScreen(element.id)),
                                class: "menu-link me-1"
                              }, [
                                _hoisted_36,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('message.DELETE')), 1)
                              ], 8, ["onClick"])
                            ])
                          ])
                        ], 2)
                      ], 8, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "group", "onChange"])
            ])
          ]))
    ]),
    (_ctx.homeScreens.length == 0)
      ? (_openBlock(), _createBlock("div", _hoisted_37))
      : (_openBlock(), _createBlock("div", _hoisted_38, [
          _createVNode("span", _hoisted_39, _toDisplayString(_ctx.homeScreens?.length) + " " + _toDisplayString(_ctx.$t('message.RECORDS')), 1)
        ]))
  ]))
})